/* tslint:disable */
/* eslint-disable */
/**
 * Xerjoff.Agenti.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrdinePosDTO
 */
export interface OrdinePosDTO {
    /**
     * 
     * @type {number}
     * @memberof OrdinePosDTO
     */
    sequenza?: number;
    /**
     * 
     * @type {string}
     * @memberof OrdinePosDTO
     */
    descrizione?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OrdinePosDTO
     */
    valore?: number;
}

/**
 * Check if a given object implements the OrdinePosDTO interface.
 */
export function instanceOfOrdinePosDTO(value: object): value is OrdinePosDTO {
    return true;
}

export function OrdinePosDTOFromJSON(json: any): OrdinePosDTO {
    return OrdinePosDTOFromJSONTyped(json, false);
}

export function OrdinePosDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrdinePosDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'sequenza': json['sequenza'] == null ? undefined : json['sequenza'],
        'descrizione': json['descrizione'] == null ? undefined : json['descrizione'],
        'valore': json['valore'] == null ? undefined : json['valore'],
    };
}

  export function OrdinePosDTOToJSON(json: any): OrdinePosDTO {
      return OrdinePosDTOToJSONTyped(json, false);
  }

  export function OrdinePosDTOToJSONTyped(value?: OrdinePosDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sequenza': value['sequenza'],
        'descrizione': value['descrizione'],
        'valore': value['valore'],
    };
}

